import { Card, Form, Select, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import { formatDate } from "../../services/util";
import Chart2 from "./Chart2";
import Chart1 from "./Charts1";
import { columnChartConfigurationOptions } from "../../config";

const { Option } = Select;
const yAxisOptions = [
    { key: "hotels", title: "Hotels" },
    { key: "components", title: "Components" },
];

const xAxisOptions = [
    { key: "months", title: "Months" },
    { key: "days", title: "Days" },
    { key: "hotel_name", title: "Hotels" },
    { key: "component_name", title: "Components" },
];

function TicketsByComponents() {
    const [form] = Form.useForm();
    const { selectedDates } = useContext(SettingContext);

    const [start_date, end_date] = selectedDates;
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([]);
    const [hotelSelectionOps, setHotelSelectionOps] = useState([]);
    const [componentSelectionOps, setComponentSelectionOps] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        chart_by: xAxisOptions[0].key,
        chart_for: yAxisOptions[0].key,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        hotel_ids: [],
        all_selected: true,
    });

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "ticketByCompenets",
        async () => {
            return await HTTP("/analytics/getMonthlyComponentWiseTickets", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: hotelOptionStatus,
        data: hotehotelOptionRes,
        refetch: getHotelOptions,
    } = useQuery(
        "kiosk-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "kiosk",
            });
        },
        { enabled: false },
    );

    const {
        status: componentStatus,
        data: componentRes,
        refetch: getComponent,
    } = useQuery(
        "hubspot-components",
        async () => {
            return await HTTP("/dashboard/getJiraComponents", {
                staff_id,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        if (hotelOptionStatus === "success") {
            setHotelSelectionOps(hotehotelOptionRes.data);
        }
    }, [hotelOptionStatus, hotehotelOptionRes]);

    useEffect(() => {
        if (componentStatus === "success") {
            setComponentSelectionOps(componentRes.data);
        }
    }, [componentStatus, componentRes]);

    useEffect(() => {
        getHotelOptions();
        getChart();
        getComponent();
        form.setFieldsValue({
            chart_by: xAxisOptions[0].key,
            chart_for: yAxisOptions[0].key,
        });
    }, []);

    useEffect(() => {
        getChart();
    }, [formData]);

    useEffect(() => {
        if (chartStatus === "success") {
            const { data } = chartRes;
            setChartData(data);
        }
    }, [chartStatus, chartRes]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    function handleChartForSelection(event) {
        let updatedFormData = { ...formData };
        delete updatedFormData.component_ids;
        delete updatedFormData.hotel_ids;
        updatedFormData = {
            ...updatedFormData,
            chart_for: event,
            all_selected: true,
        };
        if (event === "components") {
            setFormData({
                ...updatedFormData,
                component_ids: [],
            });
        } else {
            setFormData({
                ...updatedFormData,
                hotel_ids: [],
            });
        }
    }

    function handelChartBySelection(e) {
        setFormData({ ...formData, chart_by: e });
    }

    function handleHotelSelection(e) {
        setFormData({
            ...formData,
            hotel_ids: e,
            all_selected: e.length > 0 ? false : true,
        });
    }

    function handleComponentSelection(e) {
        setFormData({
            ...formData,
            component_ids: e,
            all_selected: e.length > 0 ? false : true,
        });
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="chartCard  box-shadow">
                <Form
                    form={form}
                    layout="inline"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <Form.Item
                        style={{ width: "30%" }}
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.chart_for !== currentValues.chart_for
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("chart_for") == "hotels" ? (
                                <Form.Item label="Hotels" name="hotel_ids">
                                    <Select
                                        allowClear
                                        id="hotel_ids"
                                        onChange={handleHotelSelection}
                                        mode="multiple"
                                        loading={hotelSelectionOps.length === 0}
                                    >
                                        {hotelSelectionOps.map((e) => (
                                            <Option
                                                key={e.hotel_id}
                                                value={e.hotel_id}
                                            >
                                                {`${e.hotel_id} - ${e.hotel_name}`}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            ) : (
                                <Form.Item
                                    label="Components"
                                    name="component_ids"
                                >
                                    <Select
                                        allowClear
                                        id="component_ids"
                                        onChange={handleComponentSelection}
                                        mode="multiple"
                                        loading={
                                            componentSelectionOps.length === 0
                                        }
                                    >
                                        {componentSelectionOps.map((c) => (
                                            <Option
                                                key={c.component_id}
                                                value={c.component_id}
                                            >
                                                {c.component_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.chart_by !== currentValues.chart_by
                        }
                        style={{ width: "30%" }}
                    >
                        {({ getFieldValue }) => (
                            <Form.Item label="Y-Axis" name="chart_for">
                                <Select
                                    id="chart_for"
                                    onChange={handleChartForSelection}
                                >
                                    {yAxisOptions.map((e) => {
                                        const chartBySelected =
                                            xAxisOptions.find(
                                                (e) =>
                                                    e.key ==
                                                    getFieldValue("chart_by"),
                                            );

                                        return (
                                            <Option
                                                key={e.key}
                                                value={e.key}
                                                disabled={
                                                    chartBySelected?.title ==
                                                    e.title
                                                }
                                            >
                                                {e.title}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        )}
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.chart_for !== currentValues.chart_for
                        }
                        style={{ width: "30%" }}
                    >
                        {({ getFieldValue }) => (
                            <Form.Item label="X-Axis" name="chart_by">
                                <Select
                                    id="chart_by"
                                    onChange={handelChartBySelection}
                                >
                                    {xAxisOptions.map((e) => {
                                        const chartForSelected =
                                            yAxisOptions.find(
                                                (e) =>
                                                    e.key ==
                                                    getFieldValue("chart_for"),
                                            );
                                        return (
                                            <Option
                                                key={e.key}
                                                value={e.key}
                                                disabled={
                                                    chartForSelected?.title ==
                                                    e.title
                                                }
                                            >
                                                {e.title}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        )}
                    </Form.Item>
                </Form>
                {chartData.length > 0 ? (
                    <Chart
                        className="charts"
                        chartType="ScatterChart"
                        height="80vh"
                        options={{
                            ...columnChartConfigurationOptions,
                            title: "Tickets By Components",
                        }}
                        data={chartData}
                    />
                ) : (
                    <Skeleton
                        title={false}
                        active={true}
                        paragraph={{ rows: 10 }}
                    />
                )}
            </Card>
            <Card className="box-shadow margin-10">
                <Chart1 />
            </Card>
            <Card className="chartCard chartWithDatePicker box-shadow margin-10">
                <Chart2 />
            </Card>
        </Card>
    );
}
export { TicketsByComponents };
